"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get baseBuilder () {
        return baseBuilder;
    },
    get sourceBuilder () {
        return sourceBuilder;
    }
});
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const baseBuilder = (0, _apiv3datatransformationbuilder.builderGenerator)({
    allowed: [
        'id',
        'title',
        'description',
        'created_at',
        'updated_at',
        'meta',
        'sources',
        'default_role',
        'fk_workspace_id'
    ],
    mappings: {
        name: 'title',
        isMeta: 'is_meta',
        source: 'sources',
        fk_workspace_id: 'workspace_id'
    },
    meta: {
        snakeCase: true,
        metaProps: [
            'meta'
        ]
    },
    transformFn: (base)=>{
        if (base.default_role === 'no-access') {
            base.type = 'private';
        }
        delete base.default_role;
        return base;
    }
});
const sourceBuilder = (0, _apiv3datatransformationbuilder.builderGenerator)({
    allowed: [
        'id',
        'alias',
        'type',
        'is_schema_readonly',
        'is_data_readonly',
        'integration_id'
    ],
    mappings: {
        alias: 'title',
        isMeta: 'is_meta',
        source: 'sources'
    }
});
